import ApiService from '../services/apiService';

export const createOvertimeAgreementRequest = ({ dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('post', '/overtime_agreements', {
    dispatch,
    params,
    formData,
    successCallback,
    callback
  });

export default createOvertimeAgreementRequest;
